import baseAPI from '@/api/base';
import {
  EditYurtzeiten,
  GetYurtzeiten,
  RegisterYurtzeiten,
} from '@/dtos/yurtzeiten.dto';
import {
  DELETE_YURTZEITEN_URL,
  EDIT_YURTZEITEN_URL,
  GET_YURTZEITEN_URL,
  REGISTER_YURTZEITEN_URL,
  TOGGLE_YURTZEITEN_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Yurtzeiten {
  static getYurtzeitens = async (
    getYurtzeiten: GetYurtzeiten
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_YURTZEITEN_URL, {
      params: getYurtzeiten,
    });
    console.log('response', response);
    return response;
  };

  static registerYurtzeiten = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_YURTZEITEN_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    console.log('response', response);
    return response;
  };

  static editYurtzeiten = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_YURTZEITEN_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  static toggleYurtzeitenIsActive = async (
    editYurtzeiten: EditYurtzeiten
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_YURTZEITEN_IS_ACTIVE_URL,
      {
        ...editYurtzeiten,
      }
    );
    return response;
  };

  static deleteYurtzeiten = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_YURTZEITEN_URL}/${id}`
    );
    return response;
  };
}

export default Yurtzeiten;
